import { FC } from 'react';
import { useIntl } from 'react-intl';

const Error404: FC = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <h1 className='fw-bolder fs-4x text-gray-700 mb-10'>
        {formatMessage({ id: 'Page Not Found' })}
      </h1>

      <div className='fw-bold fs-3 text-gray-400 mb-15'>
        {formatMessage({ id: 'The page you looked not found!' })}
      </div>
    </>
  );
};

export { Error404 };
